(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eu-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const setFieldError = (form, name, message) => {
      const field = form.elements[name];
      const error = form.querySelector(`[data-error-for="${name}"]`);
      if (field && "setAttribute" in field) {
        field.setAttribute("aria-invalid", message ? "true" : "false");
      }
      if (error) {
        error.textContent = message || "";
      }
    };

    const setStatus = (section, type, message) => {
      const status = section.querySelector("[data-withdrawal-status]");
      if (!status) return;
      status.classList.remove("is-success", "is-error");
      if (type) {
        status.classList.add(`is-${type}`);
      }
      status.textContent = message || "";
    };

    const setLoading = (section, isLoading) => {
      const button = section.querySelector("[data-submit-button]");
      const label = section.querySelector("[data-submit-label]");
      const form = section.querySelector("[data-withdrawal-form]");
      section.classList.toggle("is-loading", isLoading);
      if (button) {
        button.disabled = isLoading;
        button.setAttribute("aria-busy", isLoading ? "true" : "false");
      }
      if (form) {
        form.setAttribute("aria-busy", isLoading ? "true" : "false");
      }
      if (label) {
        label.textContent = isLoading ? section.dataset.loadingText : section.dataset.submitText;
      }
    };

    const validate = (section, form) => {
      const requiredMessage = section.dataset.requiredMessage;
      const emailMessage = section.dataset.emailMessage;
      const consentMessage = section.dataset.consentMessage;
      const requiredFields = ["firstName", "lastName", "email", "orderNumber", "address", "items", "message"];
      let isValid = true;

      requiredFields.forEach((name) => {
        const value = String(form.elements[name]?.value || "").trim();
        let message = "";

        if (!value) {
          message = requiredMessage;
        } else if (name === "email" && !emailPattern.test(value)) {
          message = emailMessage;
        }

        if (message) {
          isValid = false;
        }
        setFieldError(form, name, message);
      });

      const consentAccepted = Boolean(form.elements.consent?.checked);
      setFieldError(form, "consent", consentAccepted ? "" : consentMessage);
      if (!consentAccepted) {
        isValid = false;
      }

      return isValid;
    };

    const payloadFromForm = (form) => ({
      firstName: String(form.elements.firstName?.value || "").trim(),
      lastName: String(form.elements.lastName?.value || "").trim(),
      email: String(form.elements.email?.value || "").trim(),
      orderNumber: String(form.elements.orderNumber?.value || "").trim(),
      address: String(form.elements.address?.value || "").trim(),
      items: String(form.elements.items?.value || "").trim(),
      message: String(form.elements.message?.value || "").trim(),
      consent: Boolean(form.elements.consent?.checked),
      company: String(form.elements.company?.value || "").trim()
    });

    document.addEventListener("submit", async (event) => {
      const form = event.target.closest("[data-withdrawal-form]");
      if (!form) return;

      event.preventDefault();

      const section = form.closest("[data-withdrawal-section]");
      if (!section) return;

      setStatus(section, "", "");

      if (!validate(section, form)) {
        setStatus(section, "error", section.dataset.errorMessage);
        return;
      }

      const payload = payloadFromForm(form);

      if (payload.company) {
        form.reset();
        setStatus(section, "success", section.dataset.successMessage);
        return;
      }

      try {
        setLoading(section, true);
        const response = await fetch(section.dataset.endpoint, {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        let result = {};
        try {
          result = await response.json();
        } catch (error) {
          result = {};
        }

        if (!response.ok || result.success !== true) {
          throw new Error(result.error || section.dataset.errorMessage);
        }

        form.reset();
        form.querySelectorAll("[aria-invalid]").forEach((field) => field.setAttribute("aria-invalid", "false"));
        form.querySelectorAll("[data-error-for]").forEach((error) => {
          error.textContent = "";
        });
        setStatus(section, "success", section.dataset.successMessage);
      } catch (error) {
        setStatus(section, "error", error instanceof Error ? error.message : section.dataset.errorMessage);
      } finally {
        setLoading(section, false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-document-table"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProductDocuments = (root) => {
      if (!root || root.dataset.vpdInitialized === 'true') return;
      root.dataset.vpdInitialized = 'true';

      const collectionFilter = root.querySelector('[data-vpd-collection-filter]');
      const searchInput = root.querySelector('[data-vpd-search]');
      const resetButton = root.querySelector('[data-vpd-reset]');
      const emptyMessage = root.querySelector('[data-vpd-empty]');
      const searchTitle = root.dataset.searchTitle === 'true';

      const deduplicate = (container) => {
        if (!container) return;
        const products = new Map();

        container.querySelectorAll('[data-vpd-item]').forEach((item) => {
          const productId = item.dataset.productId;
          const existing = products.get(productId);

          if (!existing) {
            products.set(productId, item);
            return;
          }

          const handles = new Set(existing.dataset.collections.split(',').filter(Boolean));
          item.dataset.collections.split(',').filter(Boolean).forEach((handle) => handles.add(handle));
          existing.dataset.collections = Array.from(handles).join(',');

          const titles = new Set(existing.dataset.collectionTitle.split('||').filter(Boolean));
          item.dataset.collectionTitle.split('||').filter(Boolean).forEach((title) => titles.add(title));
          existing.dataset.collectionTitle = Array.from(titles).join('||');

          const collectionName = existing.querySelector('[data-vpd-collection-name]');
          if (collectionName) collectionName.textContent = Array.from(titles).join('\n');
          item.remove();
        });
      };

      deduplicate(root.querySelector('[data-vpd-desktop-list]'));
      deduplicate(root.querySelector('[data-vpd-mobile-list]'));

      const filterProducts = () => {
        const selectedCollection = collectionFilter ? collectionFilter.value : 'all';
        const query = searchInput ? searchInput.value.trim().toLocaleLowerCase() : '';
        const allItems = root.querySelectorAll('[data-vpd-item]');
        let visibleProducts = 0;

        allItems.forEach((item) => {
          const collections = item.dataset.collections.split(',').filter(Boolean);
          const collectionMatches = selectedCollection === 'all' || collections.includes(selectedCollection);
          const itemNoMatches = item.dataset.itemNo.toLocaleLowerCase().includes(query);
          const titleMatches = searchTitle && item.dataset.productTitle.toLocaleLowerCase().includes(query);
          const searchMatches = query === '' || itemNoMatches || titleMatches;
          const isVisible = collectionMatches && searchMatches;

          item.hidden = !isVisible;
          if (isVisible && item.closest('[data-vpd-desktop-list]')) visibleProducts += 1;
        });

        if (emptyMessage) emptyMessage.hidden = visibleProducts > 0;
      };

      collectionFilter?.addEventListener('change', filterProducts);
      searchInput?.addEventListener('input', filterProducts);
      resetButton?.addEventListener('click', () => {
        if (collectionFilter) collectionFilter.value = 'all';
        if (searchInput) searchInput.value = '';
        filterProducts();
        searchInput?.focus();
      });

      root.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-vpd-accordion]');
        if (!toggle || !root.contains(toggle)) return;

        const details = document.getElementById(toggle.getAttribute('aria-controls'));
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (details) details.hidden = expanded;
      });

      filterProducts();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('.veltuff-product-docs').forEach(initializeProductDocuments);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
